import script from "./DatesElement.vue?vue&type=script&lang=js"
export * from "./DatesElement.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__